export default __webpack_public_path__ + "static/media/54a344b3212eb9c3f536e4b8747b701e.svg";